import { useState, useEffect } from 'react';
import { tenant as tenantApi } from '../services/api';
import { PlanRequerido } from '../services/permisos';

const THEMES = [
  { id: 'dark-tech',      nombre: 'Dark tech',      desc: 'Verde · fondo oscuro · monospace',  btn: 'linear-gradient(135deg,#00e5a0,#00d4e8)', chat: '#0f1517', header: '#141c1e', headerText: '#00e5a0', msgBot: '#141c1e', msgBotText: '#e8f0f1', msgUser: 'rgba(0,229,160,0.1)', msgUserText: '#00e5a0' },
  { id: 'light-minimal',  nombre: 'Light minimal',  desc: 'Índigo · fondo blanco · sans-serif', btn: '#4F46E5',                                chat: '#f8fafc',  header: '#4F46E5',  headerText: '#fff',    msgBot: '#fff',    msgBotText: '#374151', msgUser: '#4F46E5',              msgUserText: '#fff'    },
  { id: 'warm-corporate', nombre: 'Warm corporate', desc: 'Naranja · fondo crema · amigable',   btn: '#FF6B35',                                chat: '#fdf6f0',  header: '#FF6B35',  headerText: '#fff',    msgBot: '#fff',    msgBotText: '#3d2b1f', msgUser: '#FF6B35',              msgUserText: '#fff'    },
  { id: 'elegant-dark',   nombre: 'Elegant dark',   desc: 'Rojo · azul noche · premium',        btn: '#e94560',                                chat: '#16213e',  header: '#0f3460',  headerText: '#e94560', msgBot: '#16213e', msgBotText: '#eaeaea', msgUser: '#e94560',              msgUserText: '#fff'    },
];

function MiniWidget({ theme }) {
  return (
    <div style={{ width: '160px', borderRadius: '8px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.1)', fontFamily: 'sans-serif', fontSize: '10px' }}>
      <div style={{ background: theme.header, padding: '8px 10px', display: 'flex', alignItems: 'center', gap: '6px' }}>
        <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: theme.headerText }} />
        <span style={{ color: theme.headerText, fontWeight: 600 }}>Asistente</span>
      </div>
      <div style={{ background: theme.chat, padding: '8px', display: 'flex', flexDirection: 'column', gap: '5px' }}>
        <div style={{ background: theme.msgBot, color: theme.msgBotText, padding: '5px 7px', borderRadius: '6px', maxWidth: '80%' }}>¡Hola! ¿En qué puedo ayudarte?</div>
        <div style={{ background: theme.msgUser, color: theme.msgUserText, padding: '5px 7px', borderRadius: '6px', maxWidth: '70%', alignSelf: 'flex-end' }}>Quiero info</div>
      </div>
    </div>
  );
}

export default function Webhooks({ permisos, onUpgrade }) {
  const [data, setData]               = useState(null);
  const [copied, setCopied]           = useState('');
  const [selectedTheme, setSelectedTheme] = useState('dark-tech');

  useEffect(() => { tenantApi.getMe().then(setData); }, []);

  if (!permisos?.web) return <PlanRequerido onUpgrade={onUpgrade} />;

  const copy = (text, key) => {
    navigator.clipboard.writeText(text);
    setCopied(key);
    setTimeout(() => setCopied(''), 1500);
  };

  const embedCode = data
    ? `<script\n  src="https://bot.devit.es/widget.js"\n  data-tenant="${data.tenant_id}"\n  data-theme="${selectedTheme}"\n  data-sector="${data.especialidad || 'general'}"\n></script>`
    : '';

  return (
    <div>
      <div className="topbar">
        <div>
          <div className="page-title">Widget Web</div>
          <div className="page-sub">Instala el chatbot en tu web</div>
        </div>
      </div>
      <div className="content">

        {/* Endpoint */}
        <div className="url-block" style={{ marginBottom: '16px' }}>
          <div className="url-label">Web Widget Endpoint</div>
          <div className="url-row">
            <span className="url-text">{data?.webhook_web || 'Cargando...'}</span>
            <button className="copy-btn" onClick={() => copy(data?.webhook_web, 'web')}>
              {copied === 'web' ? '✓' : '⎘'}
            </button>
          </div>
          <div style={{ marginTop: 8, fontSize: 10, color: 'var(--text3)' }}>Endpoint del widget para tu web</div>
        </div>

        {/* Theme picker + embed code */}
        <div className="card">
          <div className="card-title">Widget flotante — elige tu estilo</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '12px', margin: '12px 0 20px' }}>
            {THEMES.map(th => (
              <div key={th.id} onClick={() => setSelectedTheme(th.id)}
                style={{ cursor: 'pointer', borderRadius: '8px', border: selectedTheme === th.id ? '2px solid var(--green)' : '1px solid var(--border)', overflow: 'hidden', transition: 'border-color 0.15s' }}>
                <div style={{ background: th.chat, padding: '10px', display: 'flex', justifyContent: 'center' }}>
                  <MiniWidget theme={th} />
                </div>
                <div style={{ padding: '8px 10px', background: 'var(--bg3)' }}>
                  <div style={{ fontSize: 11, color: selectedTheme === th.id ? 'var(--green)' : 'var(--text)', fontWeight: selectedTheme === th.id ? 500 : 400 }}>{th.nombre}</div>
                  <div style={{ fontSize: 10, color: 'var(--text3)', marginTop: 2 }}>{th.desc}</div>
                </div>
              </div>
            ))}
          </div>
          <div className="card-title">Código de embed</div>
          <div style={{ background: 'var(--bg)', border: '1px solid var(--border2)', borderRadius: '6px', padding: '12px 14px', fontSize: '11px', color: 'var(--cyan)', lineHeight: '1.7', whiteSpace: 'pre' }}>
            {embedCode}
          </div>
          <div style={{ marginTop: 10 }}>
            <button className="btn btn-ghost" style={{ fontSize: 11, padding: '6px 14px' }} onClick={() => copy(embedCode, 'embed')}>
              {copied === 'embed' ? '✓ Copiado' : '⎘ Copiar código'}
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}
